import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Modal, TextField, Grid, Card, CardMedia, Divider, IconButton, Paper
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import logo from './memphispassive.jpg';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import emailjs from 'emailjs-com';

export default function PublicListingDetail() {
  const { state } = useLocation();
  const { listing } = state;
  const [modalOpen, setModalOpen] = useState(false);
  const [carouselOpen, setCarouselOpen] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);
useEffect(() => {
  emailjs.init('5od5RiWaN2AsVbXhJ'); // This must match your PUBLIC key
}, []);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    subject: `Hey, I'm interested in ${listing.unit}!`
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = () => {
    const templateParams = {
  firstName: formData.firstName,
  lastName: formData.lastName,
  email: formData.email,
  phone: formData.phone,
  subject: formData.subject,
  unit: listing.unit
};


    emailjs.send('service_jszer4l', 'template_c3z9z2t', templateParams, '5od5RiWaN2AsVbXhJ' )

      .then(() => {
        alert('Email sent successfully');
        setModalOpen(false);
      })
      .catch((error) => {
        console.error('EmailJS error:', error);
        alert('Failed to send email.');
      });
  };

  return (
    <Box>
      {/* NAVBAR */}
      <Box
        sx={{
          backgroundColor: '#fff',
          borderBottom: '1px solid #ddd',
          px: 4,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <img src={logo} alt="Memphis Passive Logo" style={{ height: 60 }} />
          <Box sx={{ display: 'flex', gap: 4, fontWeight: 500 }}>
            {['Home', 'Rentals', 'Contact Us', 'Apply Now', 'Renter Qualification'].map(label => (
              <Typography
                key={label}
                variant="body1"
                sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
              >
                {label}
              </Typography>
            ))}
          </Box>
        </Box>
      </Box>

      {/* MAIN CARD */}
      <Box sx={{ maxWidth: 1000, mx: 'auto', px: 2, py: 4 }}>
        <Card sx={{ p: 4, borderRadius: 3, boxShadow: 4 }}>
          <Typography variant="h5" fontWeight={600} gutterBottom align="center">
            {listing.unit}
          </Typography>

          {/* MAIN IMAGE */}
          <CardMedia
            component="img"
            height="380"
            image={listing.thumbnail}
            alt={listing.unit}
            sx={{ objectFit: 'cover', borderRadius: 2, mb: 2 }}
            onClick={() => { setCarouselIndex(0); setCarouselOpen(true); }}
          />

          {/* IMAGE GALLERY */}
          {listing.images?.length > 0 && (
            <Grid container spacing={1} mb={3}>
              {listing.images.map((img, i) => (
                <Grid item xs={3} key={i}>
                  <Card sx={{ cursor: 'pointer' }} onClick={() => { setCarouselIndex(i); setCarouselOpen(true); }}>
                    <CardMedia
                      component="img"
                      image={img}
                      alt={`Listing image ${i + 1}`}
                      sx={{ height: 100, objectFit: 'cover' }}
                    />
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

          {/* DETAILS */}
          <Typography variant="subtitle1" fontWeight={600} align="center">
            {listing.beds} | {listing.baths} | {listing.size} sqft
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1} paragraph align="center">
            Section 8 and HUD-VASH Vouchers Accepted!
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph align="center">
Vouchers Accepted. Spacious 4-Bedroom, 2-Bathroom Home at 818 Laurel Street in Memphis. This well-maintained home offers a functional layout with plenty of space for families or roommates. Located in a quiet neighborhood, it is just minutes from shopping and dining. We accept Section 8, HUD-VASH, and second-chance applicants. No appliances included. To apply as a second-chance applicant, visit https://podio.com/webforms/28228194/2235189. Section 8 applicants can text the word READY to nine zero one two four five two zero nine one and follow the instructions.          </Typography>

          <Typography variant="h6" color="primary" gutterBottom align="center">
            ${listing.rent.toLocaleString()} / month
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" gutterBottom align="center">
            AVAILABLE {new Date(listing.availableDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}
          </Typography>

          {/* CTA BUTTONS */}
          <Box sx={{ display: 'flex', gap: 2, my: 3, justifyContent: 'center' }}>
            <Button variant="contained" color="success" onClick={() => setModalOpen(true)}>
              Request Information
            </Button>
            <Button
              variant="outlined"
              href="https://memphispassive.managebuilding.com/Resident/rental-application/new"
              target="_blank"
            >
              Apply for this Unit
            </Button>
          </Box>
        </Card>

        {/* FOOTER */}
        <Typography variant="body2" color="text.secondary" align="center" mt={4}>
          Memphis Passive LLC<br />
          8016 U.S. 70 | Memphis, TN 38133<br />
          <a href="mailto:support@memphispassive.com">support@memphispassive.com</a> | 901-560-9221
        </Typography>
      </Box>

      {/* REQUEST INFO MODAL */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box sx={{ backgroundColor: '#fff', borderRadius: 2, maxWidth: 700, mx: 'auto', mt: 10, p: 4 }}>
          <Paper elevation={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <CardMedia
                component="img"
                image={listing.thumbnail}
                sx={{ width: 100, height: 75, objectFit: 'cover', borderRadius: 1 }}
              />
              <Box>
                <Typography fontWeight={600}>{listing.unit}</Typography>
                <Typography variant="body2">Single family | {listing.beds} | {listing.baths}</Typography>
                <Typography variant="body2" color="primary">View Listing</Typography>
              </Box>
            </Box>
            <Box textAlign="right">
              <Typography fontWeight={600}>${listing.rent.toLocaleString()}</Typography>
              <Typography variant="caption" color="text.secondary">AVAILABLE {new Date(listing.availableDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}</Typography>
            </Box>
          </Paper>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}><TextField fullWidth label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} /></Grid>
            <Grid item xs={12} sm={6}><TextField fullWidth label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Email" name="email" value={formData.email} onChange={handleChange} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Phone Number" name="phone" value={formData.phone} onChange={handleChange} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Subject" name="subject" value={formData.subject} onChange={handleChange} /></Grid>
          </Grid>

          <Box textAlign="right" mt={3}>
            <Button onClick={() => setModalOpen(false)} sx={{ mr: 2 }}>Cancel</Button>
            <Button variant="contained" color="success" onClick={handleSubmit}>Submit</Button>
          </Box>
        </Box>
      </Modal>

      {/* IMAGE CAROUSEL MODAL */}
      <Modal open={carouselOpen} onClose={() => setCarouselOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
            maxWidth: '90vw',
            maxHeight: '90vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <IconButton
            onClick={() => setCarouselIndex((carouselIndex - 1 + listing.images.length) % listing.images.length)}
            sx={{ position: 'absolute', left: 16, zIndex: 10 }}
          >
            <ChevronLeftIcon fontSize="large" />
          </IconButton>

          <CardMedia
            component="img"
            image={listing.images?.[carouselIndex] || listing.thumbnail}
            alt={`Image ${carouselIndex + 1}`}
            sx={{ maxHeight: '80vh', maxWidth: '100%', borderRadius: 2 }}
          />

          <IconButton
            onClick={() => setCarouselIndex((carouselIndex + 1) % listing.images.length)}
            sx={{ position: 'absolute', right: 16, zIndex: 10 }}
          >
            <ChevronRightIcon fontSize="large" />
          </IconButton>
        </Box>
      </Modal>
    </Box>
  );
}